import { EMPLOYER_CONTACT_US_URL_PROPS } from '@seek/shared-constants';

import type { UrlResolver } from 'src/types';

export const getContactUsUrl = (urlResolver: UrlResolver) =>
  urlResolver(EMPLOYER_CONTACT_US_URL_PROPS);
